// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import InvestingComboBoxTemplate from '../../TradingPlatformTemplates/InvestingComboBoxTemplate.html';
import { TerceraComboBox } from '@front/controls/elements/TerceraComboBox';
import { closeContextMenuEvent, hideContextMenu, openContextMenu } from './InvestingMenu';
export class InvestingComboBox extends TerceraComboBox {
    constructor() {
        super();
    }
    getType() {
        return 'InvestingComboBox';
    }
    MenuShow() {
        const posElement = this.find('*').getBoundingClientRect();
        const width = posElement.width;
        const height = posElement.height;
        const posX = posElement.left + window.pageXOffset;
        const posY = posElement.top + window.pageYOffset + height;
        void this.set('focused', true);
        const additionalParams = {
            width: this.get('listWidth') || width,
            isShiftComboBox: height
        };
        this.set('isMenuShown', true);
        openContextMenu(posX, posY, this.menuItems, additionalParams);
        closeContextMenuEvent.Subscribe(this.LostFocus, this);
    }
    HideMenu() {
        hideContextMenu();
    }
    LostFocus() {
        closeContextMenuEvent.UnSubscribe(this.LostFocus, this);
        void this.set('focused', false);
        this.set('isMenuShown', false);
    }
}
TerceraComboBox.extendWith(InvestingComboBox, {
    template: InvestingComboBoxTemplate,
    data: function () {
        return {
            showLastValue: false,
            items: [],
            selectedItem: null,
            tooltip: '',
            listWidth: 0,
            usePNGView: false,
            showArrow: true,
            infoBtnTooltip: '',
            updateComboBoxClass: '' // Развитие возможно всегда. Идеал — цель, которая всегда меняется. Эволюция никогда не останавливается. Нельзя останавливаться!
        };
    }
});
